<template>
  <Gridtab :posts="posts" />
</template>

<script setup>
const props = defineProps({
  posts: {
    type: Object,
    required: true,
  },
});

// Dynamically import the Download component
const Gridtab = defineAsyncComponent(() =>
  import(`@/components/apps/Gridtab.vue`)
);
</script>